import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { FileTextIcon, CalculatorIcon, MessageSquareIcon, BellIcon, ClipboardCheckIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function WhatYouGet() {
  const items = [{
    icon: FileTextIcon,
    title: 'El Kit de Emergencia (Guía PDF)',
    description: 'El manual paso a paso para identificar y detener las fugas de dinero en menos de 60 minutos.'
  }, {
    icon: CalculatorIcon,
    title: 'La Calculadora del Impuesto TDAH',
    description: 'Para que veas exactamente cuánto estás regalando y pongas fin al autoengaño.'
  }, {
    icon: MessageSquareIcon,
    title: 'Guiones de "Cancelación Sin Estrés"',
    description: 'Copia y pega estos mensajes para terminar con suscripciones difíciles sin tener que hablar con nadie.'
  }, {
    icon: BellIcon,
    title: 'El Protocolo de Blindaje de Calendario',
    description: 'Cómo configurar alertas inteligentes que tu cerebro no pueda ignorar.'
  }, {
    icon: ClipboardCheckIcon,
    title: 'Lista de Verificación de Auditoría de 10 Minutos',
    description: 'El sistema visual para revisar tus cuentas sin entrar en pánico ni parálisis.'
  }];
  return <section className="py-24 bg-brand-cream" data-id="element-152">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-153">
        <FadeIn data-id="element-154">
          <div className="text-center mb-16" data-id="element-155">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-teal mb-4" data-id="element-156">
              Lo que obtienes hoy
            </h2>
            <div className="w-16 h-[2px] bg-brand-gold mx-auto" data-id="element-157"></div>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-158">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} className={index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''} data-id="element-159">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-brand-teal/5 h-full relative overflow-hidden group hover:shadow-md transition-shadow" data-id="element-160">
                <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-161"></div>
                <item.icon className="w-10 h-10 text-brand-gold mb-6" strokeWidth={1.5} data-id="element-162" />
                <h3 className="text-xl font-bold text-brand-teal mb-3 font-serif" data-id="element-163">
                  {item.title}
                </h3>
                <p className="text-brand-charcoal/70 leading-relaxed" data-id="element-164">
                  {item.description}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="mt-16 text-center" data-id="element-165">
          <Button href="#offer" data-id="element-166">Quiero Acceder Ahora</Button>
        </FadeIn>
      </div>
    </section>;
}